import { render, staticRenderFns } from "./jobInfo.vue?vue&type=template&id=edc415e2"
import script from "./jobInfo.vue?vue&type=script&lang=js"
export * from "./jobInfo.vue?vue&type=script&lang=js"
import style0 from "./jobInfo.vue?vue&type=style&index=0&id=edc415e2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc415e2')) {
      api.createRecord('edc415e2', component.options)
    } else {
      api.reload('edc415e2', component.options)
    }
    module.hot.accept("./jobInfo.vue?vue&type=template&id=edc415e2", function () {
      api.rerender('edc415e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job/jobInfo.vue"
export default component.exports